import * as React from "react";
import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import Draggable, { DraggableCore } from "react-draggable"; // Both at the same time
import { FxmsEvent, AlarmLevel } from "../actions/FxEvent";
import { FxmsData } from "../datas/FxData";
import { FxPopupOpener } from "../windows/FxWindows";
import { LineZoomChart } from "./charts/FxLineZoomChart";
import { AttrListEdit } from "../datas/OpClass";

/**
 * 이미지보드에 올라갈 ITEM
 * @param {*} props
 * @returns
 */
const MoBoardItem = (props) => {
  const { item, onDrag, onClickMoItem, isAlarmDisp } = props;
  const unit =
    item.moItem.psItem.psUnit === "-" ? "" : item.moItem.psItem.psUnit;
  const alarmCss = isAlarmDisp
    ? "alarmBackground_" + item.moItem.alarmLevel
    : "";

  return (
    <Draggable
      defaultPosition={{ x: item.x, y: item.y }}
      id={"Draggable_" + item.key}
      onDrag={onDrag}
      grid={[8, 8]}
      bounds="parent"
    >
      <Tooltip title={item.moItem.mo.moName}>
        <div
          className={"FxImageBoardItem " + alarmCss}
          onClick={function (e) {
            onClickMoItem(item.moItem);
          }}
          id={item.key}
        >
          {item.moItem.value}
          <span> {unit}</span>
        </div>
      </Tooltip>
    </Draggable>
  );
};

const FacilityBoardItem = (props) => {
  const { item, onDrag, onClickMoItem, isAlarmDisp } = props;
  const facItem = item.facItem;

  function Render() {
    let sensorName = [];
    for (const moItem of facItem.moItemList) {
      sensorName.push(
        <>
          <div
            className="SensorName"
            key={"mo" + moItem.mo.moNo}
            onClick={function (e) {
              onClickMoItem(moItem);
            }}
          >
            {moItem.psItem.psName}
          </div>
          <div
            className="SensorValue"
            onClick={function (e) {
              onClickMoItem(moItem);
            }}
          >
            {moItem.value +
              " " +
              (moItem.psItem.psUnit === "-" ? "" : moItem.psItem.psUnit)}
          </div>
        </>
      );
    }
    return sensorName;
  }

  return (
    <Draggable
      defaultPosition={{ x: item.x, y: item.y }}
      id={"Draggable_" + item.key}
      onDrag={onDrag}
      grid={[8, 8]}
      bounds="parent"
    // disabled = {true}
    >
      <Tooltip title={facItem.fac.facName}>
        <div className="SensorBoxContainer" id={item.key}>
          <div className="SensorBoxHeader" id={item.key}>
            {facItem.fac.facName + "(" + facItem.fac.facTid + ")"}
          </div>
          <div className="SensorBoxContent" id={item.key}>
            {Render()}
          </div>
        </div>
      </Tooltip>
    </Draggable>
  );
};

/**
 *
 * @param {*} props
 * @returns
 */
export const FxImageBoard = (props) => {
  const { id, fxUiGrp, fxUiGrpItem, editable, attrObj } = props;
  const inputObj = attrObj ? attrObj : fxUiGrpItem.attrObj;
  const [backgroundImg, setBackgroundImg] = useState(
    fxUiGrpItem && fxUiGrpItem.attrObj && fxUiGrpItem.attrObj.bgImageName
      ? fxUiGrpItem.attrObj.bgImageName
      : "FxImageBoard.jpg"
  );
  const [title, setTitle] = useState("");
  const [psHstTitle, setPsHstTitle] = useState("수집이력보기");
  const [children, setChildren] = useState([]);
  const [selectedData, setSelectedData] = useState({});
  const opObj = FxmsData.getOpObj("ui-mo-create");
  const openPopup = React.useRef(null);
  let itemData = null;
  let isAlarmDisp = true;

  function onClickMoItem(moItem) {
    if (moItem.mo.moNo >= 0 && moItem.psItem) {
      setSelectedData({ mo: moItem.mo, psItem: moItem.psItem });
      setPsHstTitle(
        "수집이력보기 " + moItem.mo.moName + " : " + moItem.psItem.psName
      );
      openPopup.current();
    }
  }

  function doRender() {
    // 실시간 수집자료 수신 요청
    for (const item of itemData.getItemList()) {
      if (item.moItem) {
        FxmsEvent.addValuePeek(
          item.moItem.mo.moNo,
          item.moItem.psItem.psId,
          showData
        );
      } else if (item.facItem) {
        for (const moItem of item.facItem.moItemList) {
          FxmsEvent.addValuePeek(moItem.mo.moNo, moItem.psItem.psId, showData);
        }
      }
    }

    // 알람 수신 요청
    FxmsEvent.addAlarmListener(recvAlarm, "FxImageBoard");

    setChildren(makeChild());
  }

  useEffect(() => {
    console.log("*** FxImageBoard ***  fxUiGrpItem.opObj ", fxUiGrpItem.opObj);
    if (fxUiGrpItem.opObj) {
      const val = fxUiGrpItem.opObj.getAttrValue("alarm", "Y");
      isAlarmDisp = "N" === val;
    }
  }, []);

  useEffect(() => {
    console.log("*** FxImageBoard *** mount " + id, inputObj, opObj);

    if (inputObj) {
      let keys = Object.keys(inputObj);
      for (let key of keys) {
        if (key === "bgImageName") {
          setBackgroundImg(inputObj[key]);
          break;
        }
      }

      setTitle(inputObj.title);

      if (inputObj.itemData) {
        itemData = inputObj.itemData;
        doRender();
      } else {
        itemData = new ItemData(fxUiGrpItem.opObj);
        itemData.setInputObj(inputObj, doRender);
      }
    }

    return () => {
      console.log("*** FxImageBoard *** unmount " + id);
    };
  }, [attrObj]);

  const makeChild = function () {
    if (itemData === null) {
      return [];
    }

    let ret = [];

    // 저장버튼
    // ret.push(
    //   <div key="btnSave" className="imagePositionSave">
    //     <Button onClick={clickSave} id="btnSave" className="save">
    //       Save
    //     </Button>
    //   </div>
    // );

    for (let item of itemData.getItemList()) {
      if (item.moItem) {
        ret.push(
          <MoBoardItem
            key={item.key}
            item={item}
            onDrag={drag}
            onClickMoItem={onClickMoItem}
            isAlarmDisp={isAlarmDisp}
          />
        );
      } else if (item.facItem) {
        try {
          ret.push(
            <FacilityBoardItem
              key={item.key}
              item={item}
              onDrag={drag}
              onClickMoItem={onClickMoItem}
              isAlarmDisp={isAlarmDisp}
            />
          );
        } catch (error) {
          console.log("*** FxImageBoard ***  error ", error);
        }
      }
    }

    return ret;
  };

  // 알림 내용 표시
  function recvAlarm(alarm) {
    if (itemData === null) return;

    const moItem = itemData.getMoItem(alarm.moNo);
    if (moItem) {
      moItem.alarmLevel = AlarmLevel.getName(
        FxmsEvent.getAlarmReceiver().getAlarmTopLevel(alarm.moNo)
      );
    }

    setChildren(makeChild());
  }

  // 값 표시
  function showData(recvObj) {
    if (itemData === null) return;

    const moItem = itemData.getMoItem(recvObj.moNo);
    if (moItem) {
      try {
        moItem.value = recvObj.value
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } catch (e) {
        moItem.value = "-";
      }
    }

    setChildren(makeChild());
  }

  // 위치 변경 내역 기록
  const clickSave = function (event) {
    let inObj = itemData.getInputObj();
    inObj.bgImageName = backgroundImg;
    FxmsData.updateUi(fxUiGrp, fxUiGrpItem, inObj);
  };

  //관리대상 위치 변경되면 보관함
  const drag = (event, data) => {
    let item = itemData.getItem(event.target.id);
    if (item != null) {
      item.x = data.x;
      item.y = data.y;
    }
  };

  // 그릴 내용 전달
  return (
    <>
      <div>
        <div id={id} className="FxImageBoard">
          <div className="FxImageBoardTitle">
            {title} <span>Monitoring</span>
          </div>
          <img className="FxImageBoardImage" src={backgroundImg} />
          {children}
        </div>
      </div>
      {/* 항목을 클릭했을 때 팝업 화면 뛰우기 */}
      <FxPopupOpener openPopup={openPopup} title={psHstTitle}>
        <LineZoomChart selectedData={selectedData} />
      </FxPopupOpener>
    </>
  );
};

/**
 * 이미지보드 설정
 * 개발자 : T/F팀
 * 개발년원 : 2022.11
 * @param {*} fxUiGrp 
 * @param {*} fxUiGrpItem 
 * @returns 
 */
export function FxImageBoardConfig(fxUiGrp, fxUiGrpItem) {

  const setList = new AttrListEdit("setting");
  setList.makeAttrText(10, "title", "타이틀", 400);
  setList.makeAttrText(20, "bgImageName", "배경이미지", 300);
  setList.makeAttrButton(40, "btnSave", "적용", 100, null, function (data) {
    FxmsData.updateUi(fxUiGrp, fxUiGrpItem, data);
  });

  return setList;

}

/**
 * 이미지보드컨테이너 설정
 * 개발자 : T/F팀
 * 개발년원 : 2022.11
 * @param {*} fxUiGrp 
 * @param {*} fxUiGrpItem 
 * @returns 
 */
export function FxImageBoardContainerConfig(fxUiGrp, fxUiGrpItem) {

  const setList = new AttrListEdit("setting");
  setList.makeAttrSelect(10, "facNo", "컨테이너", 300, "facility", { facClCd: "M002" });
  setList.makeAttrText(20, "bgImageName", "배경이미지", 300);
  setList.makeAttrButton(30, "btnSave", "적용", 100, null, function (data) {
    FxmsData.updateUi(fxUiGrp, fxUiGrpItem, data);
  });

  return setList;

}



/**
 * 컨테이너 안에 존재하는 센서를 보여준다.
 * @param {*} props
 * @returns
 */
export const FxImageBoardContainer = (props) => {
  const { id, fxUiGrp, fxUiGrpItem, editable } = props;
  const [attrObj, setAttrObj] = useState({});

  useEffect(() => {
    if (fxUiGrpItem.opObj && fxUiGrpItem.opObj.attrList) {
      // 관리대상을 제외한 나머지 기본 정보를 attrObj에 넣는다.
      const newAttrObj = {};
      for (let attr of fxUiGrpItem.opObj.attrList) {
        if (attr.attrGrp === "fixedValue") {
          if (attr.attrTypeCd !== "mo" && attr.attrTypeCd !== "facility") {
            newAttrObj[attr.attrName] = attr.attrDftVal;
          }
        }
      }
      setAttrObj(newAttrObj);
    }

    FxmsEvent.addEventListener("FxImageBoardContainer", onFxmsEvent);
  }, []);

  async function loadFacility(facNo, attrObj) {
    const newAttrObj = { ...attrObj };
    const facData = await FxmsData.get("feFacility/" + facNo);

    if (facData && facData.data) {
      // const sensors = await FxmsData.get("feFacility/sensors/" + facNo);
      const subFacs = await FxmsData.get("feFacility/subFac/" + facNo);
      // for (const fac of subFacs.data) {
      //   const ret = await FxmsData.get("feFacility/sensors/" + fac.facNo);
      //   fac.moList = ret.data;
      // }

      // 설비안의 센서
      const container = facData.data;
      const relFacNo = [facNo];
      const tmp = new Map();

      container.moList = [];
      tmp.set(facNo, container);
      for (const fac of subFacs.data) {
        fac.moList = [];
        tmp.set(fac.facNo, fac);
        relFacNo.push(fac.facNo);
      }
      const ret = await FxmsData.GET("feFacility/sensors", {
        in_relFacNo: relFacNo,
      });
      let fac;
      for (const s of ret.data) {
        fac = tmp.get(s.relFacNo);
        if (fac) {
          fac.moList.push(s);
        }
      }
      console.log("*** FxImageBoardContainer ***", ret);

      const itemData = new ItemData(fxUiGrpItem.opObj);
      itemData.setContainer(container, container.moList, subFacs.data);

      newAttrObj.title = container.facName;
      newAttrObj.itemData = itemData;

      setAttrObj(newAttrObj);

      console.log("*** FxImageBoardContainer *** newAttrObj", newAttrObj);
    }
  }

  function onFxmsEvent(obj) {
    if (obj.facNo) {
      // console.log("*** FxImageBoardContainer ***", obj);
      loadFacility(obj.facNo, attrObj);
    }
  }

  return (
    <FxImageBoard
      id={id}
      fxUiGrp={fxUiGrp}
      fxUiGrpItem={fxUiGrpItem}
      editable={editable}
      attrObj={attrObj}
    />
  );
};

/**
 * item 구성
 * item = x, y, h, w, moItem | facItem 존재
 * moItem = mo, psItem, value, alarmLevel
 * facItem = fac, [ moItem ]
 */
class ItemData {
  constructor(opObj) {
    this.opObj = opObj;
    this.containerObj = null;
    this.moItemMap = new Map();
    this.itemList = [];
    this.attrList = this.getAttrList();
  }

  getInputObj() {
    const ret = {};
    for (const item of this.itemList) {
      if (item.moItem) {
        ret["mo_" + item.moItem.mo.moNo] =
          item.moItem.mo.moNo +
          "," +
          item.moItem.psItem.psId +
          "," +
          item.x +
          "," +
          item.y +
          "," +
          item.w +
          "," +
          item.h;
      } else if (item.facItem) {
        ret["fac" + item.facItem.fac.facNo] =
          item.facItem.fac.facNo +
          "," +
          "psId" +
          "," +
          item.x +
          "," +
          item.y +
          "," +
          item.w +
          "," +
          item.h;
      }
    }
    return ret;
  }

  getItem(key) {
    for (const item of this.itemList) {
      if (item.key === key) return item;
    }
    return null;
  }

  getMoItem(moNo) {
    return this.moItemMap.get(Number(moNo));
  }

  getItemList() {
    return this.itemList;
  }

  async setInputObj(inputObj, callback) {
    let keys = Object.keys(inputObj);
    for (let key of keys) {
      if (key.startsWith("obj") || key.startsWith("mo")) {
        const val = inputObj[key];
        const ss = val.split(",");
        if (ss.length !== 6) continue;
        const psItem = FxmsData.getPsItem(ss[1]);
        if (psItem === null) continue;

        const mo = await FxmsData.getMo(Number(ss[0]));
        if (mo) {
          const item = { key: "mo" + mo.moNo };
          this.setPosition(val, item);
          item.moItem = this.makeMoItem(mo, psItem);
          this.itemList.push(item);
        }
      }
    }

    callback();
  }

  makeMoItem(mo, psItem) {
    const ret = {
      key: "mo" + mo.moNo,
      mo: mo,
      psItem: psItem,
      value: "-",
      alarmLevel: AlarmLevel.getName(AlarmLevel.CLEAR),
    };

    this.moItemMap.set(Number(mo.moNo), ret);

    return ret;
  }

  setContainer(containerObj, moList, facList) {
    this.containerObj = containerObj;

    if (moList) {
      for (const mo of moList) {
        const item = this.getItemByMo(mo);
        if (item != null) {
          this.itemList.push(item);
        }
      }
    }

    if (facList) {
      for (const fac of facList) {
        const item = this.getItemByFac(fac);
        if (item != null) {
          this.itemList.push(item);
        }
      }
    }
  }

  getItemByMo(mo) {
    for (let attr of this.attrList) {
      if (
        attr.attrTypeCd === "mo" &&
        attr.etcInfoObj.sensrName === mo.sensrName
      ) {
        const item = {};
        const psItem = FxmsData.psItemMap.get(mo.sensrPsId);
        if (psItem === null) return null;
        item.moItem = this.makeMoItem(mo, psItem);
        this.setPosition(attr.attrDftVal, item);
        return item;
      }
    }
    return null;
  }

  getItemByFac(fac) {
    for (let attr of this.attrList) {
      if (
        attr.attrTypeCd === "facility" &&
        attr.etcInfoObj.facClCd === fac.facClCd
      ) {
        const moItemList = [];

        if (attr.etcInfoObj.moList) {
        } else if (attr.etcInfoObj.psIdList) {
          for (const psId of attr.etcInfoObj.psIdList) {
            const psItem = FxmsData.psItemMap.get(psId);
            if (psItem === null) continue;

            for (const sensor of fac.moList) {
              if (sensor.sensrPsId === psId) {
                sensor.moName = sensor.sensrName;
                const moItem = this.makeMoItem(sensor, psItem);
                moItemList.push(moItem);
              }
            }
          }
        }

        const ret = { key: "fac" + fac.facNo };
        ret.facItem = { fac: fac, moItemList: moItemList };
        this.setPosition(attr.attrDftVal, ret);

        return ret;
      }
    }
    return null;
  }

  getAttrList() {
    if (this.opObj === null || this.opObj === undefined) {
      return null;
    }

    if (this.opObj.attrList === null || this.opObj.attrList === undefined) {
      return null;
    }

    const ret = [];
    for (const attr of this.opObj.attrList) {
      if (attr.attrGrp === "fixedValue" && attr.etcInfoObj) {
        ret.push(attr);
      }
    }
    return ret.length === 0 ? null : ret;
  }

  setPosition(s, obj) {
    let ss = s.split(",");

    if (ss.length === 6 || ss.length == 4) {
      let i = ss.length === 6 ? 2 : 0;
      obj.x = parseInt(ss[i]);
      obj.y = parseInt(ss[i + 1]);
      obj.w = parseInt(ss[i + 2]);
      obj.h = parseInt(ss[i + 3]);
    } else {
      obj.x = 100;
      obj.y = 100;
      obj.w = 100;
      obj.h = 100;
    }
  }
}

export default FxImageBoard;
